import ReportManagerForm from './component'

export default ReportManagerForm
